<template>
  <div class="about"   id="about">
     <div class="bannerBox">
         <img class="bannerImg" v-if="inwidth>768" :src="list.banner" alt="">
         <img class="bannerImg" v-else :src="list.phone_pic" alt="">
     </div>
     <div class="overAllBox about-main" >
         <div class="about-main-top  animate__animated animate__fadeInUpBig wow" data-wow-offset="10"  >
             <div class="about-main-tleft pr">
                 <div class="about-main-tleft-Div">
                     <div class="about-main-tleft-Title ">{{list.leftbox_title}}</div>
                     <div class="about-main-tleft-Text"></div>
                 </div>
                 <!-- {{list.leftbox_title_en}} -->
                 <!-- <img class="hengxian" src="../../../static/images/about_ht.png" alt=""> -->
                 <img class="w h csbg" :src="list.leftimg" alt="">
             </div>   
             <div class="about-main-tright ">
                <div class="about-main-tright-Title">{{list.about_title}}</div>
                <div class="about-main-tright-Text">{{list.about_content1}}</div>
             </div>
         </div>
         <div class="about-main-bottom animate__animated animate__fadeInUpBig wow" data-wow-offset="10"  >
             <div class="about-main-bleft">
                 {{list.about_content2}}
             </div>
             <div class="about-main-bright-Div pr">
                  <!-- <img class="hengxian2" src="../../../static/images/about_ht.png" alt=""> -->
                 <img class="w h limg" :src="list.rightimg" alt="">
             </div>
         </div>
     </div>
     <!-- <div class="about-btBox pr animate__animated animate__fadeInUpBig wow" data-wow-offset="10"     :style="{'height':height}"   >
         <div class="about-btBox-left  pr"  >
             <div class="about-btBox-left-Div " >
                 <div class="about-btBox-left-hezi" v-if="inwidth>768"  @scroll.passive="getScroll($event)">
                    <div  v-for="(item,index) in list.timeline" :key="index" class="about-btBox-left-li " :class="current==index?'about-btBox-left-active':''">
                     <div class="about-btBox-left-Dot"></div>
                     <div class="about-btBox-left-Title "  v-on:mouseenter="downSwitch(index)"  @click="downSwitch(index)">{{item.date}}</div>
                     <div class="about-btBox-left-Dot"></div>
                    </div>
                 </div>
                 
                 <img src="../../../static/images/about_down.png" class="about-down"  @click="downSwitchscroll()" alt="">
             </div>
         </div>
         <div class="about-btBox-center"    >
             <div class="about-btBox-center-pt" style=" "></div>
         
             <div class="about-btBox-center-title3 about-btBox-center-marginX acvntext" v-if="list.timeline">{{list.timeline[current].date}}</div>
             <div class="about-btBox-center-text about-btBox-center-marginX acvntext" v-if="list.timeline">{{list.timeline[current].content}}</div>
         </div>
         <div class="about-btBox-right pr exchange" :class="current">
             <i ></i>
             <img class="w h  cavnImg" :class="index==current?'disblock':'disNone'" v-for="(item,index) in list.timeline" :key="index"  :src="item.pic" alt="">
         </div>
     </div> -->
     <!-- <div class="overAllBox about-footer about-fp animate__animated animate__backInUp">
         <div class="about-footer-title">{{list.title}}</div>
         <div class="about-footer-text">{{list.title_text}}</div>
         <div class="about-footer-text">{{list.title_text2}}</div>
        
         <div class="about-footer-Div">
             <div  class="about-footer-Div-li " v-for="item in list.sblist" :key="item.pic">
                 <img class="about-footer-Div-liImg" :src="item.pic" alt="">
                 <div class="about-footer-Div-liDiv">
                    <div class="about-footer-Div-liTitle">{{item.title}}</div>
                 </div>
             </div>
             <div style="clear:both"></div>
         </div>
     </div> -->
     <!-- <div class="overAllBox about-footer animate__animated animate__fadeInUpBig wow"  data-wow-offset="10" >
         <div class="about-footer-title">{{list.title2}}</div>
         <div class="about-footer-text">{{list.title2_text}}</div>
        
         <div class="about-footer-Div2" v-if="inwidth>414" >
             <div  class="about-footer-Div2-li"  v-for="item in list.sblist2" :key="item.pic">
                 <img class="w h about-footer-Div2-liImg"  :src="item.pic" alt="">
             </div>
         </div>
         <swiper :options="swiperOption"  v-else>
            <swiper-slide class="swiper-slide about-footer-Div2" style="padding-bottom:3.5rem" v-for="(item,index) in brand" :key="index">
                <div  class="about-footer-Div2-li"  v-for="items in item" :key="items.pic">
                    <img class="w h about-footer-Div2-liImg"  :src="items.pic" alt="">
                </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
     </div> -->
     <!-- <div class="animate__animated animate__fadeInUpBig" style="margin-bottom:2rem" v-if="list.video"> -->
        <video class="swiper-img myvideo" :style="{'height':videoheight}"   loop    muted  autoplay  :src="list.video"  playsinline="true" webkit-playsinline="true"  preload="auto"></video>
     <!-- </div> -->
  </div>
</template>
<script>
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import {WOW} from 'wowjs';
export default {
  name: "about",
  components: {
    Header,
    Footer
  },
  data() {
    return {
        videoheight:'',
        src:'https://dss0.bdstatic.com/-0U0bnSm1A5BphGlnYG/cae-legoup-video-target/ad06f462-fdac-4588-a19f-87190aecccca.mp4',
       current:0,
       swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        // direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        // autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        // mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        // height: window.innerHeight, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        loop: true,
        autoplay: false,
        autoplay: {
          disableOnInteraction: false,
          delay:5000,
        },
        speed:1500,
      },
       list:{ },
       scrollBottom:'',
       inwidth:window.innerWidth,
       cuImg:true,
       height:'auto',
       brand:[],
    };
  },
  watch:{
      current(){
        //   $('.cavnImg').attr('style','display:block')
        //   this.cuImg=true

      }
  },
  created(){
      this.about()
  },
  mounted(){
       new WOW().init();

        let inwidth=window.innerWidth
        var getScreenHeight = function() {
            return document.documentElement ? document.documentElement.clientHeight : window.innerHeight;
        };
        if(inwidth<=1024){
            this.height=100-7.3+'vh'
            this.videoheight=(getScreenHeight() -50)+'px';
        }else{//pc端
        this.videoheight=(getScreenHeight()  - $('.header').height()) + "px" 
        }

       
        // this.height = `${document.documentElement.clientHeight}`+'px'
        window.addEventListener('scroll', this.onScroll2)
  },
  methods:{
       //关于接口
    about() {
      var that = this;
      let data = {};
      that.$api.about(data).then(res => {
        if (res.status == 1) {
           that.list=res.data;
            let brand='';
            let j = -1;
            let k = 0;
            for (var i = 0; i < this.list.sblist2.length; i++) {
            if (i % 4 == 0) {
                j++;
                k = 0;
            }
            if (!this.brand[j]) {
                this.brand[j] = {};
            }
                this.brand[j][k] = this.list.sblist2[i];
                k++;
            };
            
        } else {
          that.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
     onScroll2(){
        //  if(Math.floor( $(document).scrollTop())==Math.floor( $(".about-btBox-center").offset().top)){
        //      $(document).animate({scrollTop:$(".about-btBox-center").offset.top},300);
        //  }
         
     },
    getScroll(event){
        let inwidth=window.innerWidth
        if(inwidth<=1024){
            this.scrollBottom =
            event.target.scrollWidth -
            event.target.scrollLeft -
            event.target.clientWidth;
       }else{
           this.scrollBottom =
            event.target.scrollHeight -
            event.target.scrollTop -
            event.target.clientHeight;
       }
   
        
    },
    downSwitchscroll(){
       var that=this
        $('.acvntext').removeClass('animate__animated animate__fadeInUp')
        $('.acvntext').addClass('animate__animated animate__fadeOutDown')
        $('.about-btBox-right i').attr('style','top:0')

       
       let inwidth=window.innerWidth
        if(inwidth<=1024){
            let inwidthLeft='';
            if(inwidth<=1024&&inwidth>=768){
                inwidthLeft=inwidth*0.14
            }else if(inwidth<=768&&inwidth>414){
                inwidthLeft=inwidth*0.13
            }else if(inwidth<=414&&inwidth>375){
                inwidthLeft=inwidth*0.24
            }else if(inwidth<=375&&inwidth>320){
                inwidthLeft=inwidth*0.27
            }else if(inwidth<=320){
                inwidthLeft=inwidth*0.315
            }
            $(".about-btBox-left-hezi").scrollLeft( $(".about-btBox-left-hezi").scrollLeft()+inwidthLeft)
            if(this.scrollBottom<=inwidthLeft){
                if(this.scrollBottom<=2&&this.current==0){
                    $(".about-btBox-left-hezi").scrollLeft(0)
                }else{
                    $(".about-btBox-left-hezi").scrollLeft( $(".about-btBox-left-hezi").scrollLeft()+this.scrollBottom) 
                }
            }
       }else{
           $(".about-btBox-left-hezi").scrollTop( $(".about-btBox-left-hezi").scrollTop()+20)
           if(this.scrollBottom<20){//剩余不足20
             if(this.scrollBottom<=2&&this.current==0){
                $(".about-btBox-left-hezi").scrollTop(0)
             }else{
                $(".about-btBox-left-hezi").scrollTop( $(".about-btBox-left-hezi").scrollTop()+this.scrollBottom) 
             }
              
           } 
            
       }
       setTimeout(function(){
             if(that.current<that.list.timeline.length-1){
                that.current=that.current+1
            }else{
                that.current=0
            } 
              $('.acvntext').removeClass('animate__animated animate__fadeOutDown')
              $('.acvntext').addClass('animate__animated animate__fadeInUp')
              $('.about-btBox-right i').attr('style','top:100%')
          },500)
    },
      downSwitch(index){
        //   this.cuImg=false
        var that=this
        $('.acvntext').removeClass('animate__animated animate__fadeInUp')
        $('.acvntext').addClass('animate__animated animate__fadeOutDown')
        $('.about-btBox-right i').attr('style','top:0')
        // $('.cavnImg').attr('style','transform: scale(1.2)')
    
         
          setTimeout(function(){
               if(index||index==0){
                    that.current=index
               }else{
                    if(that.current<that.list.timeline.length-1){
                        that.current=that.current+1
                    }else{
                        that.current=0
                    }
                }
              $('.acvntext').removeClass('animate__animated animate__fadeOutDown')
              $('.acvntext').addClass('animate__animated animate__fadeInUp')
              $('.about-btBox-right i').attr('style','top:100%')
                // $('.cavnImg').attr('style','transform: scale(1)')
          },500)
        //   $(".about-btBox-left-Div ").scrollLeft(this.current*100);
      },
       
  },
  beforeDestroy() {//清除监听
        window.removeEventListener('scroll', this.onScroll2)
  },
}
</script>
<style  >
.about-btBox-right i{
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 100%;
    background-color: #ffffff;
    transition: all .4s linear;
    z-index: 998;
}
.about .bannerBox{
     width: 100%;
     /* height: 50rem; */
 }
.about .bannerImg{
     width: 100%;
     height: 100%;
     vertical-align: middle;
     object-fit: cover;
 }
 .about .about-main{
     padding-top: 6.5rem;
     margin-bottom: 6.5rem;
 }
.about .about-main-top{
     display: flex;
     justify-content: space-between;
 }
.about .about-main-tleft{
     width: 45%;
     height: 51.5rem;
     overflow: hidden;
 }
.about .about-main-tleft-Div{
     position:absolute;
     top:0;
     left:0;
     width: 100%;
     height: 100%;
     overflow: hidden;
 }
.about .about-main-tleft-Title{
     font-size: 2.4rem;
     font-weight: bold;
     color: #ffffff;
     padding-top: 2.5rem;
     margin: 0 2.8rem;
     margin-bottom: 1.5rem;
     
 }
.about .about-main-tleft-Text{
     font-size: 1.6rem;
     color: #ffffff;
     line-height: 2.8rem;
     margin: 0 10rem 0 2.8rem;
 }
.about .hengxian{
     position: absolute;
     right: 1rem;
     top: 20rem;
     width: 12rem;
     height: 0.1rem;
 }

 .about .hengxian2{
     position: absolute;
     left:-6rem;
     top: 50%;
     width: 12rem;
     height: 0.1rem;
 }
.about .about-main-tright{
     width: 51%;
     height: 51.5rem;
 }
 .about .about-main-tright-Title{
     font-size: 3.6rem;
     font-weight: bold;
     color: #4c4c4c;
     margin-bottom: 3.6rem;
     letter-spacing:0.2rem;
 }
 .about-main-tright-Text{
     font-size: 1.4rem;
     color: #4c4c4c;
     line-height: 3rem;
    /* word-break: break-all;
    word-wrap: break-word;  
    white-space: pre-wrap; */
    text-align:justify; 
    text-justify:inter-ideograph;
 
 }
 .about .about-main-bottom{
     display: flex;
     align-items: flex-start;
     justify-content: space-between;
     margin-top: 3.7rem;
 }
 .about .about-main-bright-Div{
     width: 55%;
     height: 28.4rem;
 }
 .about .about-main-bleft{
     width: 39%;
     line-height: 3rem;
     font-size: 1.4rem;
     color: #4c4c4c;
    /* word-break: break-all;
    word-wrap: break-word;  */
    text-align:justify; 
    text-justify:inter-ideograph;
 }
 .about .about-btBox{
     display: flex;
     align-items: center;
     /* visibility: unset; */
 }
 .about  .about-btBox-left{
     width: 50%;
     height: 65.8rem;
     background-color: #f3f3f3;
 }
  .about .about-btBox-right{
     width: 50%;
     height: 65.8rem;
     /* display: flex;
     align-items: center;
     justify-content: center; */
     overflow: hidden;
 }
 
  .about .about-btBox-left-Div{
     padding-top: 5.5rem;
     width: 15.3rem;
     margin: 0 auto;
 }
  .about .about-btBox-left-li{
     display: flex;
     align-items: center;
     justify-content: space-between;
     margin-bottom: 4rem;
     transition: all .4s linear;
 }
  .about .about-btBox-left-Dot{
    width: 3rem;
    height: 0.1rem;
    background-color: rgba(0, 0, 0, 0);
    transition: all .4s linear;
 }
  .about .about-btBox-left-Title{
     color: #808080;
     font-size: 1.8rem;
     cursor: pointer;
     transition: all .2s linear;
 }
  .about .about-btBox-left-active .about-btBox-left-Title{
     color: #4c4c4c;
     font-size: 2.4rem;
 }
  .about .about-btBox-left-active .about-btBox-left-Dot{
     background-color: #000000;
 }
 .se{
     background-color: red;
     width: 100%;
 }
  .about .about-down{
     width: 4rem;
     height: 4rem;
     border-radius: 50%;
     margin: 0 auto;
     display: block;
     cursor: pointer;
     margin-top: 2rem;
 }
  .about .about-btBox-center{
     width: 29.5%;
     padding-bottom: 4rem;
     /* height: 35.2rem; */
     background-color: #ffffff;
     position: absolute;
     left:50%;
     top: 50%;
     transform: translateY(-50%) translateX(-50%);
     /* margin-top: -17.51rem; */
     box-shadow: -8px 8px 20px #999999;
     z-index: 1000;
     overflow: hidden;
     opacity: 0.9;
 }
 .about .about-btBox-center-pt{
    padding-top: 3.2rem;
}
  .about .about-btBox-center-title1{
     color: #999999;
     font-size: 1.4rem;
     margin-bottom: 1rem;
 }
  .about .about-btBox-center-title2{
     color: #999999;
     font-size: 1.4rem;
 }
  .about .about-btBox-center-Dot{
     width: 0.1rem;
     height: 6.7rem;
     background-color: #e6e6e6;
     margin-top: 2rem;
     margin-bottom: 2rem;
 }
  .about .about-btBox-center-title3{
     color: #4c4c4c;
     font-size:3.6rem;
     margin-bottom: 1rem;
 }
  .about .about-btBox-center-text{
     color: #4c4c4c;
     font-size:1.4rem;
     line-height: 3.5rem;
 }
  .about .about-btBox-center-marginX{
     margin-left: 4rem;
     margin-right: 2.5rem;
 }
  .about .about-footer{
     margin-bottom: 6rem;
     text-align: center;
 }
  .about .about-fp{
     padding-top: 6rem;
 }
  .about .about-footer-title{
     color: #4c4c4c;
     font-size: 3rem;
     margin-bottom: 1rem;
     letter-spacing: 0.2rem;
     font-weight: bold;
 }
 .about  .about-footer-text{
     color: #999999;
     font-size: 1.6rem;
     line-height: 3rem;
 }
 .about  .about-footer-Div{
     margin-top: 6rem;
     display: flex;
     flex-wrap: wrap;
 }
  .about .about-footer-Div-li{
     width: 16.5%;
     height: 36.5rem;
     border-right: 0.1rem solid #e6e6e6;
     text-align: center;
 }
  .about .about-footer-Div-li:first-child{
     border-left: 0.1rem solid #e6e6e6;
 }
  .about .about-footer-Div-liDiv{
     text-align: center;
     margin: 0 1rem;
     transition: all .5s; 
 }
  .about .about-footer-Div-liImg{
     max-width: 16.7rem;
     height: 11rem;
     margin: 4.5rem auto 13.4rem;
     display: block;
     transition: all .5s;  
 }
  .about .about-footer-Div-liTitle{
     font-size: 1.6rem;
     color: #333333;
     margin-bottom: 0.08rem;
 }
  .about .about-footer-Div-liText{
     font-size: 1.4rem;
     color: #999999;
 }

 .about-footer-Div2{
     display: flex;
     align-items: center;
     flex-wrap: wrap;
 }
 .about-footer-Div2-li{
     width: 13.4%;
     /* height: 6.8rem; */
     margin-top: 2.5rem;
     margin-right: 1rem;
     transition: all 0.5s;
 }


.about-btBox-left-hezi{
    height: 46rem;
    overflow-y: scroll;
}
.about-btBox-left-hezi::-webkit-scrollbar{
        display: none;
}

.cavnImg{
    transition: all 0.5s linear;
}

.about .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
    bottom: 0rem;
}
 .about  .swiper-pagination .swiper-pagination-bullet-active {
  background-color: #333333;
}
/*当浏览器尺寸pc时候的代码：*/
@media screen and  (min-width:1024px) and (max-width: 3000px){
     .about-footer-Div-li:hover .about-footer-Div-liImg,.about-footer-Div-liDiv{
         margin-top: -1rem;
     }
     .about-footer-Div2-li:hover{
        transform: scale(1.2);
        box-shadow: 0px 10px 10px #f5f5f5;
    }
}
/*当浏览器尺寸1024x时候的代码：*/
@media screen and (min-width:767px) and (max-width: 1024px){
     .about .bannerBox{
        height: auto;
    }
    .about  .about-main{
        padding-top: 4.5rem;
    }
   .about .about-main-top{
        flex-wrap: wrap;
    }
   .about .about-main-tleft{
        width: 100%;
        height: auto;
    }
   .about .about-main-tright {
        width: 100%;
        height: auto;
    }
   .about .about-main-tright-Title{
        margin-top: 3rem;
        text-align: center;
    }
   .about .about-main-bottom{
        margin-top: 2rem;
    }
    .about  .hengxian{
        display: none;
    }
   .about   .hengxian2{
        display: none;
    }
 .about   .about-footer-Div-liDiv{
        margin-top: -5rem;
    }
   .about .about-footer-Div{
        flex-wrap: wrap;
    }
   .about .about-footer-Div-li{
        width: 33%;
        height: 30.5rem;
    }
  .about  .about-footer-Div-li:nth-child(4){
        border-left: 0.1rem solid #e6e6e6
    }
  .about  .about-footer-Div2-li{
        width: 23.4%;
    }
  .about  .about-btBox{
        flex-direction:column-reverse;
        flex-wrap: wrap;
    }
  .about  .about-btBox-left{
        width: 100%;
        height: auto;
    }
  .about  .about-btBox-right{
        width: 100%;
        height: auto;
    }
   
  .about  .about-btBox-center{
        width: 80%;
        /* right: 10%;
        top: 73%; */
    }
   .about .about-btBox-left-Div{
        width: 80%;
        height: 20rem;
        display: flex;
        align-items: center;
        overflow-x: scroll;
        padding-top: 20rem;
    }
   .about .about-btBox-left-Div::-webkit-scrollbar{
        display: none;
    }
  .about  .about-down{
        position: absolute;
        bottom: 4rem;
        left: 50%;
        margin-left: -2rem;
        z-index: 999;
        transform:rotate(-90deg);
    } 
   .about .about-btBox-left-hezi{
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        overflow-x: scroll;
    }
    .about .csbg{
        /* margin-left: 3%; */
        object-fit: cover;
        width: 120%;
        height: 100%;
    }
}

/*当浏览器尺寸小于768px时候的代码：手机端 */ 
@media screen and (max-width:768px){
    .about  .bannerImg{
        height: 40rem;
    }
   .about  .about-footer-Div2-li{
        width: 23.4%;
    }
   .about  .about-footer-Div-liDiv{
        margin-top: -5rem;
    }
   .about  .csbg{
        /* margin-left: 3%; */
        object-fit: cover;
        width: 120%;
        height: 100%;
    }
 
    .about .about-footer-Div-liImg{
        margin: 4.5rem auto 9rem;
    }
    
    
}
/*当浏览器尺寸小于750px时候的代码：手机端 */ 
@media screen and (max-width:750px){
    .about .about-btBox-center-title3{
        font-size: 3.6rem;
    }
    .about .about-btBox-center-text{
     color: #4c4c4c;
     font-size:1.4rem;
     line-height: 2.4rem;
    }
    
}
/*当浏览器尺寸小于414px时候的代码：手机端 */ 
@media screen and (max-width:414px){
     .about .limg{
        height: 25rem;
        object-fit: cover;
    }
      .about  .bannerImg{
        height: 40rem;
    }
    .about  .about-main{
        padding-top: 4.5rem;
    }
   .about   .about-main-top{
        flex-wrap: wrap;
    }
   .about   .about-main-tleft{
        width: 100%;
        height: auto;
    }
   .about   .about-main-tright {
        width: 100%;
        height: auto;
    }
   .about   .about-main-tright-Title{
        margin-top: 3rem;
        text-align: center;
    }
   .about   .about-main-bottom{
        margin-top: 2rem;
        flex-wrap: wrap;
    }
   .about  .hengxian{
        display: none;
    }
  .about  .hengxian2{
        display: none;
    }
    .about  .about-main-bleft{
        width: 100%;
    }
    .about  .about-main-bright-Div{
        width: 100%;
        margin-top: 2rem;
        height: auto;
    }
    .about  .about-footer-Div{
        display: block;
        
        /* flex-wrap: wrap;
        justify-content: center; */
        width: 100%;
    }
   .about   .about-footer-Div-liDiv{
        margin-top: -5rem;
    }
   .about   .about-footer-Div::-webkit-scrollbar{
        display: none;
    }
   .about   .about-footer-Div-li {
        width: 32%;
        height: 20rem;
        float: left;
    }
    
   
    .about  .about-footer-Div-li:nth-child(4){
        border-left: 0.1rem solid #e6e6e6
    }
    .about  .about-footer-Div-liImg{
        width: auto;
        height: 20%;
    }
 
    .about  .about-footer-Div-liTitle{
        font-size: 1.6rem;
    }
    .about  .about-footer-Div-liText{
        font-size: 1.2rem;
    }
   
    .about  .about-footer-Div2{
        justify-content: space-between;
    }
    .about  .about-footer-Div2-li{
        width: 47.5%;
         margin-right: 0;
    }
    .about  .about-btBox{
        flex-direction:column-reverse;
        flex-wrap: wrap;
    }
   .about   .about-btBox-left{
        width: 100%;
        height: auto;
        flex: 1;
    }
   .about   .about-btBox-right{
        width: 100%;
        height: auto;
    }
    
     .about .about-btBox-center{
        width: 80%;
    }
    .about  .about-btBox-center-marginX{
        margin-left: 1.5rem;
        margin-right: 2rem;
    }
    
    .about  .about-btBox-left-Div{
        position: absolute;
        left: 9%;
        bottom: 0;
        width: 82%;
        height: 18rem;
        display: flex;
        align-items: center;
        overflow-x: scroll;
        /* padding-top: 20rem; */
        /* padding-left: 3rem;
        padding-right: 3rem; */
    }
    .about  .about-btBox-left-Div::-webkit-scrollbar{
        display: none;
    }
    .about  .about-btBox-left-li{
        margin-bottom: 0rem;
    }
     .about .about-down{
        position: absolute;
        bottom: 4rem;
        left: 50%;
        margin-left: -2rem;
        z-index: 999;
        transform:rotate(-90deg);
    } 
    .about  .about-btBox-left-hezi{
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        overflow-x: scroll;
    }
   .about   .about-main-bottom{
        margin-top: 1rem;
        flex-direction: column-reverse;
    }
    .about  .about-main-bright-Div{
        margin-top: 1rem;
        margin-bottom: 2rem;
    }
    
}
/*当浏览器尺寸小于414px时候的代码：手机端 */ 
@media screen and (max-width:375px){
    
   
    .about  .about-footer-Div{
        /* flex-wrap: wrap;
        justify-content: center; */
        width: 100%;
        display: block;
        /* flex-wrap: nowrap; */
        /* overflow-x: scroll; */
    }
    .about  .about-footer-Div-liDiv{
        margin-top: -5rem;
    }
    .about  .about-footer-Div::-webkit-scrollbar{
        display: none;
    }
   .about   .about-footer-Div-li {
        width: 32%;
        height: 27.5rem;
    }
    
   
   .about   .about-footer-Div-li:nth-child(4){
        border-left: 0.1rem solid #e6e6e6
    }
    .about  .about-footer-Div-liImg{
        width: auto;
        height: 20%;
    }
 
   .about   .about-footer-Div-liTitle{
        font-size: 1.6rem;
    }
    .about  .about-footer-Div-liText{
        font-size: 1.2rem;
    }
    
}
/*当浏览器尺寸小于414px时候的代码：手机端 */ 
@media screen and (max-width:320px){
    .about  .about-footer-Div2-li{
        width: 47.5%;
    }
    
    .about  .about-btBox-center-pt{
        padding-top: 2.2rem;
    }
     .about .about-btBox-center-Dot{
        margin-top: 1rem;
        margin-bottom: 1rem;
        height: 4.7rem;
    }
    .about  .about-btBox-left-hezi{
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        overflow-x: scroll;
    }
    .about  .bannerImg{
        height: 40rem;
    }
    .about  .about-footer-Div-liTitle{
        font-size: 1.4rem;
    }
    .about  .about-footer-Div-liText{
        font-size: 1.2rem;
    }
      .about .about-btBox-center-title3{
        font-size: 3rem;
    }
   .about .about-btBox-center-text{
     color: #4c4c4c;
     font-size:1.4rem;
     line-height: 2.4rem;
    }
}

.swiper-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  vertical-align: middle;
}
 

</style>